import React from 'react';
import { BaseModalProps } from '../../types/modal.types';
import { useLanguage } from '../../context/LanguageContext';
import LanguageSwitcher from '../UI/LanguageSwitcher';

const BaseModal: React.FC<BaseModalProps> = ({
  amount,
  currency = 'VES',
  badge,
  onClose,
  showCloseButton = true,
  children
}) => {
  const { t } = useLanguage();

  const formatAmount = (value: string | undefined) => {
    if (!value) return '0';
    const num = parseFloat(value);
    return num.toLocaleString('en-US');
  };

  const formattedAmount = formatAmount(amount);

  return (
    <div className="base-modal">
      <div className="base-modal__header">
        {/* <div className="base-modal__logo">
          <svg width="42" height="42" viewBox="0 0 42 42" fill="none" xmlns="http://www.w3.org/2000/svg">
            <circle cx="21" cy="21" r="21" fill="#3B82F6"/>
            <path d="M12 15L21 21L12 27V15Z" fill="white"/>
            <path d="M18 12L30 21L18 30V12Z" fill="white" fillOpacity="0.7"/>
          </svg>
          <span className="base-modal__logo-text">LOGO</span>
        </div> */}
        <div className="base-modal__header-right">
          <LanguageSwitcher />
          {/* {showCloseButton && (
            <button type="button" className="base-modal__close" onClick={onClose}>
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M18 6L6 18M6 6L18 18" stroke="#9CA3AF" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
              </svg>
            </button>
          )} */}
        </div>
      </div>

      <div className="base-modal__amount-section">
        <div className="base-modal__currency-icon">
          <span>Bs</span>
        </div>
        <div className="base-modal__amount">
          <span className="base-modal__amount-value">{formattedAmount}</span>
          <span className="base-modal__amount-currency">{currency}</span>
        </div>
      </div>

      <div className="base-modal__instructions">
        <p>{t('instruction1')}</p>
        <p>{t('instruction2', { amount: formattedAmount })}</p>
        <p>{t('instruction3')}</p>
      </div>

      {children}
    </div>
  );
};

export default BaseModal;
